import type React from "react";
import { Icon } from "../Icon";

export interface MapPlaceholderProps {
  /**
   * Container style
   */
  style?: React.CSSProperties;
  /**
   * Additional CSS classes
   */
  className?: string;
  /**
   * Custom message to display
   * @default "Map requires Mapbox token"
   */
  message?: string;
}

/**
 * MapPlaceholder
 *
 * Placeholder component shown when Mapbox token is not available.
 * Used by StaticMap and InteractiveMap when VITE_MAPBOX_ACCESS_TOKEN is not set.
 */
export function MapPlaceholder({ style, className, message = "Map requires Mapbox token" }: MapPlaceholderProps) {
  return (
    <div
      style={style}
      className={`flex items-center justify-center bg-background-muted text-text-muted ${className || ""}`}
    >
      <div className="text-center">
        <Icon name="MapPin" size={48} className="mx-auto mb-2 opacity-50" />
        <p className="text-sm">{message}</p>
      </div>
    </div>
  );
}
